// extracted by mini-css-extract-plugin
export const root = "role-list-module--root--E9hoc";
export const headline = "role-list-module--headline--1yHHT typography-module--base--2DtHq";
export const list = "role-list-module--list--2OFGi";
export const listItem = "role-list-module--listItem--236XS";
export const avatar = "role-list-module--avatar--2Jy6q";